module.exports = " <div class=login_panel _v-d04301b2=\"\"> <form action=\"\" @submit.prevent=submit _v-d04301b2=\"\"> <input-box :content.sync=email input-type=email hint=请输入注册邮箱 _v-d04301b2=\"\"></input-box> <input-box :content.sync=password input-type=password hint=请输入密码 _v-d04301b2=\"\"></input-box> <button-box input-type=submit input-value=登录 _v-d04301b2=\"\"></button-box> </form> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d04301b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/LoginPanel.vue
 ** module id = 365
 ** module chunks = 2
 **/